import React, { useState, useEffect, useMemo } from "react";
import { database, firestore } from "../../database/firebase";
import { Header } from "../../components";
import Table from "../../components/Table";


function AdminRecord() {
    const [adminDataRes, setAdminDataRes] = useState([]);
    const [adminCell, setAdminCell] = useState([]);
    const [uUid, setuUid] = useState("");
    const [adminId, setAdminId] = useState("");
    const [showModal, setShowModal] = useState(false);
    //  const [deleteModal, setDeleteModal] = useState(false);
    useEffect(() => {
        const fetchAdmin = async () => {
            console.log(adminDataRes);

            let uid = localStorage.getItem("uid");
            let role = localStorage.getItem("role");
            let userUid = JSON.parse(uid);
            setuUid(userUid);

   
            //Get admin records
            if (role === "master" ||role === "developer" ) {
                database.child(`users`).once("value", (snap) => {
                    const admin = snap.val();
                    setAdminCell([admin]);
                    let users = [];

                    for (var key in admin) {
                        // setAdminDataRes(prevArray => [...prevArray, admin[key]])
                        users.push(admin[key])
                    }
                    const adminFilter = users.filter(adminInfo => adminInfo.role === "admin");
                    setAdminDataRes(adminFilter);
                });
            }

            if (role === "superadmin" || role === "superview") {
                database.child(`users`).once("value", (snap) => {
                    const admin = snap.val();
                    setAdminCell([admin]);
                    let users = [];

                    for (var key in admin) {
                        users.push(admin[key])
                    }

                    database.child(`accounts/superAdmin/${userUid}/casaAcc`).once("value", (snap) => {
                        const superAdmin = snap.val();
                        let superAdminUid = [];
                        for (var key in superAdmin) {
                            superAdminUid.push(admin[key])
                        }
                        setAdminDataRes(superAdminUid);
                        //console.log(superAdmin);
                    });
                });
            }
        };
        fetchAdmin();
    }, []);

    const showCard = (val) => {
        setShowModal(true);
        setAdminId(val);
    };

    //   const showDelete = () => {
    //     setDeleteModal(true);
    //   }

    //   const cancelDelete = () => {
    //     setDeleteModal(false);

    //   }



    //   const deleteAdmin = (aUid) => {

    //     database.child(`users/${aUid}`)
    //       .remove()
    //       .then(() => {
    //         console.log('Record deleted.');
    //       })
    //       .catch((error) => {
    //         console.log('error rtd', error);
    //       });

    //     setShowModal(false);
    //   }
    const columns = useMemo(
        () => [
            {
                Header: "Username",
                accessor: "username",
            },
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Action",
                accessor: "uid",
                Cell: ({ cell }) => (
                    <button value={cell.value}
                        className=" w-full bg-blue-600 text-white text-base font-regular py-2 px-6 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
                        onClick={e => showCard(e.target.value)}>
                        View
                    </button>
                )
            },
        ],
        []
    );


    const data = useMemo(() => adminDataRes);

    return (
        <>
            <div className="md:flex">
                <aside class="md:h-screen md:sticky md:top-0">
                    <Header />
                </aside>


                {showModal ? (
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-auto my-6 mx-auto max-w-max">

                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                        <p className="text-medium  font-normal pr-10 text-black-900">
                                            Admin ID: {adminId}
                                        </p>

                                        <button
                                            className="p-1 ml-auto  border-0 text-black-900 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => setShowModal(false)}
                                        >
                                            <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                ×
                                            </span>
                                        </button>
                                    </div>
                                    {/*body*/}
                                    <div className="sm:flex justify-between">

                                        <div className="p-5 mx-5">

                                            <p className="text-lg text-gray-500 font-sans font-normal">
                                                Username</p>
                                            <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                {adminCell['0'][adminId].username}</p>
                                            <p className="text-lg text-gray-500 font-sans font-normal">
                                                Email</p>
                                            <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                {adminCell['0'][adminId].email}</p>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
                <div className="max-width m-auto p-5 mt-20 md:ml-40 text-gray-900 " >


                    <div className="flex justify-between h-14">
                        <p className="text-4xl  mb-10 mr-2 text-blue-700 font-sans font-bold ">
                            Accounts Record
                        </p>
                    </div>

                    <div className="mt-4 rounded-xl bg-white shadow-2xl sm:p-10">

                        {adminDataRes.length === 0 ?
                            <div>Loading...</div>
                            :
                            <>
                                <Table
                                    columns={columns}
                                    data={data}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    )

}

export default AdminRecord;